import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForftpUserComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'user.name', 'username', 'homedir', 'ip'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'username',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'homedir',
      sortable: true,
    },
    {
      property: 'user',
      type: 'relation',
      sortable: true,
    },
    {
      property: 'ip',
      sortable: true,
    },
    {
      property: 'purpose',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
  ];
}
